module.exports = __webpack_public_path__ + "img/co4.474aeea4.png";